import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';

@Component({
    selector: 'app-sec002-card-VII',
    templateUrl: './sec002-card-VII.component.html'
})

export class Sec002CardVIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listOptionsFxAzulCampo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsFxAzulUmidade?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsFxTempSecagem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsFxSemVaporVent?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsFxRessecagem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsFxTransbordo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsFxTempCarga?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsFxTempPatio?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsFxEscuroTempCarga?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsFxEscuroTempPatio?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsFxEscuroTempTransporte?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    @Output() mkCalc = new EventEmitter();

    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Faixa de Qualidade (FISIOLÓGICA)', false);
        if (this.isComercial || this.isBasica) {
            this.formulario = this.formBuilder.group({
                Faixa_azul_campo: [null, []],
                Faixa_azul_umidade_de_colheita: [null, []],
                Faixa_azul_temperatura_de_secagem: [null, []],
                Faixa_azul_sem_vapor_ou_ventilacao: [null, []],
                Faixa_azul_ressecagem: [null, []],
                Faixa_azul_transbordo: [null, []],
                Faixa_azul_claro_temperatura_carga: [null, []],
                Faixa_azul_claro_tempo_de_patio: [null, []],
                Faixa_azul_escuro_temperatura_carga: [null, []],
                Faixa_azul_escuro_tempo_de_patio: [null, []],
                Faixa_azul_escuro_granel_tempo_de_transporte: [null, []],
            });
        }
        else if (this.isPreBasica) {
            this.formulario = this.formBuilder.group({
                Faixa_azul_campo: [null, [Validators.required]],
                Faixa_azul_umidade_de_colheita: [null, [Validators.required]],
                Faixa_azul_ressecagem: [null, [Validators.required]],
                faixa_azul_tempo_de_patio: [null, [Validators.required]],
            });
        }

    }

    public async ngOnInit(): Promise<void> {
        await this.getLists();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getLists(): Promise<void> {
        await this.getListOption();
        await this.getDropdownFxTempSecagem();
    }

    async getFilters(): Promise<void> {
        await Promise.all([this.createFilterFxAzulCampo(),
        this.createFilterFxAzulUmidColheita(),
        this.createFilterFxAzulTempSec(),
        this.createFilterFxAzulVaporVen(),
        this.createFilterFxAzulRessec(),
        this.createFilterFxAzulTransbordo(),
        this.createFilterFxAzulClrTempCarga(),
        this.createFilterFxAzulClrTempPatio(),
        this.createFilterFxAzulEscrTempCarga(),
        this.createFilterFxAzulEscrTempPatio(),
        this.createFilterFxAzulEscrGranelTempTransporte()]);
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    private async getListOption(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'ultima_carga').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listOptionsFxAzulCampo = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listOptionsFxAzulUmidade = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listOptionsFxSemVaporVent = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listOptionsFxRessecagem = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listOptionsFxTransbordo = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listOptionsFxTempCarga = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listOptionsFxTempPatio = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listOptionsFxEscuroTempCarga = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listOptionsFxEscuroTempPatio = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listOptionsFxEscuroTempTransporte = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listOptionsOriginal = this.listOptionsFxAzulCampo;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async createFilterFxAzulCampo(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsFxAzulCampo = this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsFxAzulCampo = this.listOptionsOriginal;
            }
        } else {
            this.listOptionsFxAzulCampo = this.listOptionsOriginal;
        }
    }

    async createFilterFxAzulUmidColheita(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsFxAzulUmidade = this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsFxAzulUmidade = this.listOptionsOriginal;
            }
        } else {
            this.listOptionsFxAzulUmidade = this.listOptionsOriginal;
        }
    }

    async createFilterFxAzulTempSec(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsFxTempSecagem = this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsFxTempSecagem = this.listOptionsOriginal;
            }
        } else {
            this.listOptionsFxTempSecagem = this.listOptionsOriginal;
        }
    }

    async createFilterFxAzulVaporVen(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsFxSemVaporVent = this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsFxSemVaporVent = this.listOptionsOriginal;
            }
        } else {
            this.listOptionsFxSemVaporVent = this.listOptionsOriginal;
        }
    }

    async createFilterFxAzulRessec(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsFxRessecagem = this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsFxRessecagem = this.listOptionsOriginal;
            }
        } else {
            this.listOptionsFxRessecagem = this.listOptionsOriginal;
        }
    }

    async createFilterFxAzulTransbordo(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsFxTransbordo = this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsFxTransbordo = this.listOptionsOriginal;
            }
        } else {
            this.listOptionsFxTransbordo = this.listOptionsOriginal;
        }
    }

    async createFilterFxAzulClrTempCarga(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsFxTempCarga = this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsFxTempCarga = this.listOptionsOriginal;
            }
        } else {
            this.listOptionsFxTempCarga = this.listOptionsOriginal;
        }
    }

    async createFilterFxAzulClrTempPatio(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsFxTempPatio = this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsFxTempPatio = this.listOptionsOriginal;
            }
        } else {
            this.listOptionsFxTempPatio = this.listOptionsOriginal;
        }
    }

    async createFilterFxAzulEscrTempCarga(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsFxEscuroTempCarga = this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsFxEscuroTempCarga = this.listOptionsOriginal;
            }
        } else {
            this.listOptionsFxEscuroTempCarga = this.listOptionsOriginal;
        }
    }

    async createFilterFxAzulEscrTempPatio(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsFxEscuroTempPatio = this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsFxEscuroTempPatio = this.listOptionsOriginal;
            }
        } else {
            this.listOptionsFxEscuroTempPatio = this.listOptionsOriginal;
        }
    }

    async createFilterFxAzulEscrGranelTempTransporte(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsFxEscuroTempTransporte = this.listOptionsOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsFxEscuroTempTransporte = this.listOptionsOriginal;
            }
        } else {
            this.listOptionsFxEscuroTempTransporte = this.listOptionsOriginal;
        }
    }

    private async getDropdownFxTempSecagem(): Promise<void> {
        await this.formularioService.getListDropDownList('sec002', 'faixa_azul_temperatura_de_secagem').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listOptionsFxTempSecagem = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

}
